var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-center',{scopedSlots:_vm._u([{key:"page",fn:function(){return [_vm._v(" You do not have permission to access this page ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }